import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
  OnInit,
} from '@angular/core';
import { IProfileDTO } from '../../dto/config/profile.dto';
import { ProfileCategory } from '../../dto/enum/profile-category.enum';
import { ConfigService } from '../../service/config.service';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzTagComponent } from 'ng-zorro-antd/tag';
import { AnalyticsService } from '../../service/analytics.service';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-profile-examples',
  imports: [NzColDirective, NzRowDirective, NzTagComponent],
  templateUrl: './profile-examples.component.html',
  styleUrl: './profile-examples.component.less',
})
export class ProfileExamplesComponent implements OnInit {
  private static readonly PROFILE_CATEGORIES: ProfileCategory[] = [
    ProfileCategory.BLOGGER,
    ProfileCategory.COMPANY,
    ProfileCategory.SPORT,
    ProfileCategory.ANIMAL,
    ProfileCategory.PERSONAL,
  ];
  public readonly valuePublisher: InputSignal<
    BehaviorSubject<string> | undefined
  > = input<BehaviorSubject<string>>();
  public readonly profileDTOs: IProfileDTO[] = [];
  private readonly router: Router = inject(Router);
  private readonly configService: ConfigService = inject(ConfigService);
  private readonly analyticsService: AnalyticsService =
    inject(AnalyticsService);

  public ngOnInit(): void {
    this.profileDTOs.push(
      ...ProfileExamplesComponent.PROFILE_CATEGORIES.map(
        (profileCategory: ProfileCategory): IProfileDTO => {
          const profileDTOs: IProfileDTO[] =
            this.configService.examples.profiles.filter(
              (profileDTO: IProfileDTO): boolean =>
                profileDTO.category === profileCategory
            );
          const index: number = Math.floor(Math.random() * profileDTOs.length);
          return profileDTOs[index];
        }
      )
    );
  }

  public onTagClicked(profileDTO: IProfileDTO): void {
    const valuePublisher$: BehaviorSubject<string> | undefined =
      this.valuePublisher();
    if (valuePublisher$) {
      valuePublisher$.next(profileDTO.username);
      this.analyticsService.event('user_example_exec', {
        username: profileDTO.username,
        category: profileDTO.category,
        path: this.router.url,
      });
    }
  }
}
